module.exports = __webpack_public_path__ + "static/mail_classify180-2e3d942e0dea4adcd63682ce9a5d4ae3.png";